import TratamentoAtraumaticoIcon from '@/components/icons/IndicadoresEsb/Ampliados/TratamentosRestauradoresArt.vue'

export default {
  value: 'b6',
  label: 'Tratamento Atraumático',
  iconType: 'component',
  iconComponent: TratamentoAtraumaticoIcon,
  buscaAtiva: {},
}
